import { Injectable, inject } from '@angular/core';
import { HdContentLanguageService } from '../hd-content-language.service';

const HD_PROFILES_ASSET_BASE = '/assets/docs/human-design/profiles';
const HD_PROFILE_MARKDOWN_LANGUAGES = new Set(['nl', 'en']);

/**
 * URL-builder voor de markdown-documenten van het profiel-info-paneel: een
 * `general`-document, één document per profiel (`"4-6"`), een `roles-general`-
 * document en één document per rollen-lijn (`"roles-line-4"`), per contenttaal
 * onder `docs/human-design/profiles/{nl,en}/`. Spiegelt
 * {@link HdNodalEnvironmentsInfoService}.
 */
@Injectable({ providedIn: 'root' })
export class HdProfileInfoService {
  private readonly contentLanguage = inject(HdContentLanguageService);

  /** `file` is `'general'`, een profielsleutel (`'4-6'`), `'roles-general'` of `'roles-line-4'`. */
  markdownUrl(file: string, lang?: string): string {
    return `${HD_PROFILES_ASSET_BASE}/${this.resolveMarkdownLanguage(lang)}/${file}.md`;
  }

  private resolveMarkdownLanguage(lang?: string): string {
    const requestedLanguage = lang ?? this.contentLanguage.effectiveLang();
    const normalizedLanguage = (requestedLanguage || '').toLowerCase().split('-')[0];
    return HD_PROFILE_MARKDOWN_LANGUAGES.has(normalizedLanguage) ? normalizedLanguage : 'nl';
  }
}
